import { getDemoVideoProgress } from './lcUtils';
import { getSetJPlayerOptionsDemoVideoProgress } from '../trc/troUtils';
import { SET_LC_RESULT } from '../common/api/resultActions';
import { LC } from '../constants/measure';
import {
    SET_LC_CONTENT,
    SET_PASSAGE_HALF,
    SET_SELECTED_PASSAGE_ID,
    UPDATE_SELECTED_COMPREHENSION_RESPONSE,
    CLEANUP_PASSAGE,
    SET_MEDIA,
    SET_JPLAYER_OPTION
} from './lcActions';
import { FIRST, SECOND } from './lcConstants';
import passageReducer from './passageReducer';
import { LC_DEMO_VIDEO_PLAYER_ID } from '../common/components/demoVideos/demoVideoConstants';

export const defaultState = {
    isDataFetched: false,
    selectedPassageId: undefined,
    passage: passageReducer(undefined, {}),
    demoVideosProgress: {},
    selectedResponses: {},
    passageHalf: undefined,
};

// eslint-disable-next-line camelcase
export const getActivePassageHalf = ({ measure_result: { passage_results } }) => {
    const lastPassageResult = passage_results[passage_results.length - 1];
    const compResults = lastPassageResult.comprehension_results;
    const firstCompResultHalf = compResults[0];
    const secondCompResultHalf = compResults[1];

    if (!firstCompResultHalf.score) return FIRST;
    if (!secondCompResultHalf.score) return SECOND;

    return FIRST;
};

// eslint-disable-next-line camelcase
export const getActivePassageId = ({ measure_result: { passage_results } }) => {
    const lastPassageResult = passage_results[passage_results.length - 1];
    if (!lastPassageResult.is_complete) return lastPassageResult.passage_id;
    return null;
};

const lcReducer = (state = defaultState, action) => {
    switch (action.type) {
    case SET_SELECTED_PASSAGE_ID:
        return {
            ...state,
            selectedPassageId: action.passageId,
            passageHalf: FIRST
        };
    case SET_LC_CONTENT:
        return {
            ...state,
            isDataFetched: true,
            passage: passageReducer(state.book, action),
            selectedResponses: {},
        };
    case SET_MEDIA:
        if (action.id === LC_DEMO_VIDEO_PLAYER_ID) {
            return {
                ...state,
                activeVideoId: action.media.demoVideoId,
                demoVideosProgress: getDemoVideoProgress(state, action),
            };
        }
        return state;
    case SET_JPLAYER_OPTION:
        if (action.id === LC_DEMO_VIDEO_PLAYER_ID) {
            return {
                ...state,
                demoVideosProgress: getSetJPlayerOptionsDemoVideoProgress(state, action),
            };
        }
        return state;
    case UPDATE_SELECTED_COMPREHENSION_RESPONSE:
        return {
            ...state,
            selectedResponses: {
                ...state.selectedResponses,
                [action.payload.questionIndex]: action.payload.responseIndex,
            },
        };
    case SET_PASSAGE_HALF:
        return {
            ...state,
            passageHalf: action.passageHalf
        };
    case CLEANUP_PASSAGE:
        return {
            ...state,
            selectedResponses: {},
        };
    case SET_LC_RESULT: {
        if (action.result.measure !== LC.MEASURE) return state;
        return {
            ...state,
            selectedPassageId: state.selectedPassageId ? state.selectedPassageId : getActivePassageId(action.result),
            passageHalf: getActivePassageHalf(action.result)
        };
    }
    default:
        return state;
    }
};

export default lcReducer;
